
const horarioGridConfig = {
  idField: "idHorario",
  columns: [
    { header: "Dia", field: "DIA" },
    { header: "Horário", field: "HORARIO", 
      formatter: (value) => value !== null && value !== undefined
        ? `${(value).slice(0,5)} h` : "-"
    },
    { header: "Ativo", field: "ATIVO", 
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};

export default horarioGridConfig;